import type { ReactElement } from 'react';

import type { ExpandableFabProps } from '@bestseller-bit/frontend-community.components.expandable-fab';

import { ExpandableFab } from '@bestseller-bit/frontend-community.components.expandable-fab';

export const BuyingExpandableFab = (
    expandableFabProps: ExpandableFabProps
): ReactElement => (
    <ExpandableFab
        color="primary"
        size="medium"
        sx={{
            borderRadius: 0,
            width: 'auto !important',
        }}
        {...expandableFabProps}
    />
);
